import { DateTime } from 'luxon';
import { Vendor } from './vendor';

export namespace VendorParsers {
  export class VendorJson {
    id!: number;
    name!: string;
    email?: string;
    phone?: string;
    createdAt!: string;
  }

  export function toVendor(input: VendorJson): Vendor {
    return {
      ...input,
      createdAt: DateTime.fromISO(input.createdAt, { setZone: true }),
    };
  }
}
